import { observeAuthIdentity } from "@/auth/query-identity";
import { queryOptions } from "@tanstack/react-query";
import { apiUrl } from "@/lib/api-url";

export interface AuthSession {
  user: {
    id: string;
    role?: string | null;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export async function fetchAuthSession(): Promise<AuthSession | null> {
  const res = await fetch(apiUrl("/api/auth/get-session"));

  if (res.status === 401 || res.status === 403) {
    observeAuthIdentity(null);
    return null;
  }
  if (!res.ok) {
    throw new Error(`Failed to fetch auth session (${res.status})`);
  }

  const session = await res.json() as AuthSession | null;
  observeAuthIdentity(session?.user?.id ?? null);
  return session?.user ? session : null;
}

export const sessionQueryOptions = () =>
  queryOptions({
    queryKey: ["auth", "session"],
    queryFn: fetchAuthSession,
    staleTime: 0, // Recheck identity on focus/navigation, including changes in another tab.
  });
